module.exports = __webpack_public_path__ + "static/media/arrow-right-v2.8c81f302.svg";